﻿<script setup lang="ts">
    import { computed } from 'vue';
    import { useCodeEditStore } from '@/stores/codeEditStore.ts';

    const codeStore = useCodeEditStore();

    const cableCategoryDescription = computed(() =>
        codeStore?.selectedCode('CableCategory')?.values?.description);

    const cableScreenDescription = computed(() =>
        codeStore?.selectedCode('CableScreen')?.values?.description ?? 'None');

    const cableCode = computed(() =>
        codeStore.selectedCode('CableCode'));
</script>

<template>
    <div
        v-if="cableCode"
        class="is-flex flex-container is-flex-direction-row">
        <div class="pr-2 is-align-content-center">
            <b-icon
                :icon="cableCode.values.isValid ? 'check-circle' : 'close-circle'"
                size="is-small"
                custom-size="mdi-18px"
                :style="{ color: cableCode.values.isValid ? 'green' : 'red' }" />
        </div>
        <div>
            <p class="is-5 is-uppercase">
                {{ cableCategoryDescription }} - {{ cableScreenDescription }}
            </p>
            <h2 class="title is-3">
                {{ cableCode.values.name }}
            </h2>
            <p class="subtitle is-5 mb-2">
                {{ cableCode.values.description }}
            </p>
        </div>
    </div>
    <div v-else>
        <p>No cable code selected.</p>
    </div>
</template>

<style scoped>

</style>
